import { render, staticRenderFns } from "./DashboardSettingsPage.vue?vue&type=template&id=29bcba85&scoped=true&lang=pug&"
import script from "./DashboardSettingsPage.vue?vue&type=script&lang=ts&"
export * from "./DashboardSettingsPage.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardSettingsPage.vue?vue&type=style&index=0&id=29bcba85&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29bcba85",
  null
  
)

export default component.exports